module.exports = __webpack_public_path__ + "static/media/upgrade-performance-es.6b31234b.png";